"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_component_1 = require("./app.component");
var app_mobile_component_1 = require("./app_mobile/app_mobile.component");
var environment_1 = require("../environments/environment");
var is_mobile_1 = require("is-mobile");
var ɵ0 = environment_1.environment.apiBaseUrl, ɵ1 = {
    hasBackdrop: true,
    closeOnNavigation: true,
    disableClose: false,
    maxHeight: "90%"
};
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    AppModule.prototype.ngDoBootstrap = function (app) {
        console.log('in app module');
        if (is_mobile_1.default() ||
            environment_1.environment.name == "CORDOVA") {
            console.log('bootstrap cordova');
            app.bootstrap(app_mobile_component_1.AppMobileComponent);
        }
        else {
            app.bootstrap(app_component_1.AppComponent);
        }
    };
    return AppModule;
}());
exports.AppModule = AppModule;
